import ContentHeader from './ContentHeader'
export default ContentHeader
